export const PieChartContainer = {
  fontSize: { md: '10px', lgPlus: '12px', xl: '16px' },
  minHeight: '14.5em',
  borderInlineEnd: 'solid 2px #e5e5e5',
  alignItems: 'center',
  justifyContent: 'center',
  gap: { md: '2px', lgPlus: '8px', xl: '20px' },
  color: '#fff',
}
